import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { StyledSecondaryTypography } from "../../Theme";
import Chart from "react-apexcharts";
import { ReactComponent as ExclamatoryIcon } from "../../Icons/GraphExclamatoryIcon.svg";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";


const ResidentGraph = () => {
  const { ResidentData, OverviewStatus } = useSelector(
    (state) => state.OverView
  );
  // console.log(ResidentData)
  const Residentseries = [
    {
      name: "Count",
      data: [
        ResidentData?.monthly_counts?.jan || 0,
        ResidentData?.monthly_counts?.feb || 0,
        ResidentData?.monthly_counts?.mar || 0,
        ResidentData?.monthly_counts?.apr || 0,
        ResidentData?.monthly_counts?.may || 0,
        ResidentData?.monthly_counts?.jun || 0,
        ResidentData?.monthly_counts?.jul || 0,
        ResidentData?.monthly_counts?.aug || 0,
        ResidentData?.monthly_counts?.sep || 0,
        ResidentData?.monthly_counts?.oct || 0,
        ResidentData?.monthly_counts?.nov || 0,
        ResidentData?.monthly_counts?.dec || 0,
      ],
    },
    // {
    //   name: "Inactive",
    //   data: [
    //     ResidentData?.jan?.active || 0,
    //     ResidentData?.feb?.inactive || 0,
    //     ResidentData?.mar?.inactive || 0,
    //     ResidentData?.apr?.inactive || 0,
    //     ResidentData?.may?.inactive || 0,
    //     ResidentData?.jun?.inactive || 0,
    //     ResidentData?.jul?.inactive || 0,
    //     ResidentData?.aug?.inactive || 0,
    //     ResidentData?.sep?.inactive || 0,
    //     ResidentData?.oct?.inactive || 0,
    //     ResidentData?.nov?.inactive || 0,
    //     ResidentData?.dec?.inactive || 0,
    //   ],
    // },
    // {
    //   name: "Offboard",
    //   data: [
    //     ResidentData?.jan?.offboard || 0,
    //     ResidentData?.feb?.offboard || 0,
    //     ResidentData?.mar?.offboard || 0,
    //     ResidentData?.apr?.offboard || 0,
    //     ResidentData?.may?.offboard || 0,
    //     ResidentData?.jun?.offboard || 0,
    //     ResidentData?.jul?.offboard || 0,
    //     ResidentData?.aug?.offboard || 0,
    //     ResidentData?.sep?.offboard || 0,
    //     ResidentData?.oct?.offboard || 0,
    //     ResidentData?.nov?.offboard || 0,
    //     ResidentData?.dec?.offboard || 0,
    //   ],
    // },
  ];
  const options = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: {
        show: false,
      },
      events: {
        mouseMove: (event, chartContext) => {
          chartContext.el.style.cursor = "pointer";
        },
        mouseLeave: (event, chartContext) => {
          chartContext.el.style.cursor = "default";
        },
      },
    },

    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      labels: {
        style: {
          fontSize: "12px",
          fontFamily: "Inter, sans-serif",
          color: "#384250",
          fontWeight: 400,
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return Math.round(value);
        },
        style: {
          fontSize: "12px",
          fontFamily: "Inter, sans-serif",
          color: "#384250",
          fontWeight: 400,
        },
      },
    },
    colors: ["#800000", "#FF7C32", "#9A66FF"],
    legend: {
      show: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        // borderRadius: 8,
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      theme: false,
      style: {
        background: "#262D33",
      },
      x: {
        show: false,
      },
      y: {
        title: {
          formatter: function () {
            return "";
          },
        },
      },
      marker: {
        show: false,
      },
//       custom: function ({ series, seriesIndex, dataPointIndex, w }) {
//         const total =
//           series[0][dataPointIndex] +
//           series[1][dataPointIndex] +
//           series[2][dataPointIndex];
//         const active = series[0][dataPointIndex];
//         const inactive = series[1][dataPointIndex];
//         const offboard = series[2][dataPointIndex];
//         const month = w.globals.labels[dataPointIndex];

//         return `
//          <div class="background">
//         <div class="triangle">
       
//          <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M8 16V0L1.5 6.5L0.5 7.5L0 8L8 16Z" fill="#262D35"/>
// </svg>
       
//         </div>
//             <div class="apexcharts-tooltip-custom">
//               <div class="total-count-tip">
//               <div>
//               Total
//               </div> 
//               <div>
//               ${total} 
//               </div>
//               </div>
//               <div class="tool-tip-parent">
//               <div><svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
//               <rect x="0.490234" y="0.305664" width="8" height="8" rx="2" fill="#800000"/>
//               </svg>
//               Active 
//               </div>
//               <div>
//               ${active}
//               </div>
//             </div>
//               <div class="tool-tip-parent">
//               <div>
//                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
//               <rect x="0.490234" y="0.305664" width="8" height="8" rx="2" fill="#FF7C32"/>
//               </svg>
//               Inactive
//               </div> 
//               <div>
//                ${inactive}  
//                </div>
//               </div>
//               <div class="tool-tip-parent">
//               <div>
//               <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
//               <rect x="0.490234" y="0.305664" width="8" height="8" rx="2" fill="#9A66FF"/>
//               </svg>
//               Offboard
//               </div>
//               <div>${offboard}</div>
//               </div>
//               <div class="month-change-top">${month}${" "}${2023}</div>
//             </div>
//             </div>
//           `;
//       },
    },
    states: {
      normal: {
        filter: {
          type: "none",
          value: 0,
        },
      },
      hover: {
        filter: {
          type: "none",
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: "none",
          value: 0,
        },
      },
    },
   
  };
  return (
    <>
      {ResidentData?.overall_count ? (
        <Chart
          options={options}
          series={Residentseries}
          type="bar"
          height={400}
        />
      ) : (
        <Box
          sx={{
            borderRadius: "0px, 0px, 8px, 8px",
            padding: "16px",
            backgroundColor: "#F9FAFB",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "300px",
          }}
        >
          {OverviewStatus ? (
            <CircularProgress />
          ) : (
            <>
              {" "}
              <ExclamatoryIcon
                style={{ marginBottom: "5px", marginTop: "60px" }}
              />
              <Typography
                sx={{
                  color: "#9DA4AE",
                  fontSize: "16px",
                  fontWeight: 600,
                  width: "470px",
                  my: 0,
                  textAlign: "center",
                  marginTop: "5px",
                }}
                style={{ color: "#4D5761" }}
              >
                No statistics available for display
              </Typography>
            </>
          )}
        </Box>
      )}
    </>
  );
};

export default ResidentGraph;
